'use strict';

angular.module('app').directive('stickyHeader', function(utils, $timeout) {
    return function(scope, elem) {
        // $timeout(function () {
        $(window).on('scroll', function() {
            var windowWidth = $(window).outerWidth(),
                $header = $(elem),
                headerHeight = $header.height(),
                logo = $header.find('.logo img'),
                sliderHeight = $('.start-point').height(),
                $this = $(this),
                padding = (windowWidth < 1400) ? 0 : 75;

            if ($this.scrollTop() > headerHeight + sliderHeight - padding) {
                if ($header.css('position') !== 'fixed') {
                    $('.parent-wrapper').css({
                        'margin-top': 75
                    });
                    $header.css({
                        'position': 'fixed',
                        'top': -75
                    });
                    $header.addClass('scrolled');

                    logo.attr('src', '/images/padi-logo-white.svg');

                    $header.stop().animate({
                        'top': 0
                    }, 150);
                }
            } else {
                if ($header.css('position') === 'fixed') {
                    $header.removeClass('scrolled');
                    logo.attr('src', '/images/padi-logo.svg');
                    $header.stop().animate({
                        'top': -75
                    }, 1, 'linear', function() {
                        $header.css({
                            'top': '0',
                            'position': ''
                        });


                        $('.parent-wrapper').css({
                            'margin-top': 0
                        });
                    });
                }
            }
        });     
        // }, 300);
    };
});